<se-fe-grid seFeGridOpts="snug">
  @if (upfrontPayment || showPartialAmountInput) {
<se-fe-grid-cell seFeGridOpts="1/1@mobile">
    <se-fe-block seFeDataType="outline"  class="se-block--condensed se-block--no-margin">
      <se-fe-grid-cell seFeGridOpts="1/1@mobile">
        <app-payment-plan-installment
          [amount]="upfrontPaymentAmount"
          [isUpfrontAmount]="showPartialAmountInput || upfrontPayment.upfront_payment"
          [dueInFull]="dueInFull"
          [itemized]="itemized"
          [termSelectionDisabled]="termSelectionDisabled">
        </app-payment-plan-installment>
      </se-fe-grid-cell>
    </se-fe-block>
  </se-fe-grid-cell>
}

  @if (installments.length) {
<se-fe-grid-cell seFeGridOpts="1/1@mobile">
    @if (hasCustomDates) {
<se-fe-block seFeDataType="outline"  class="se-block--condensed se-block--no-margin">
      <app-custom-dates-selector
        [paymentTermForm]="paymentTermForm"
        [installments]="installments"
        [saleType]="saleType">
      </app-custom-dates-selector>
    </se-fe-block>
}

    @if (!hasCustomDates) {
<se-fe-block seFeDataType="outline"  class="se-block--condensed se-block--no-margin">
      @for (installment of installments; track installment; let i = $index) {
<se-fe-grid seFeGridOpts>
        <se-fe-grid-cell seFeGridOpts="1/1@mobile">
          <app-payment-plan-installment
            [amount]="installment.amount"
            [dueDate]="installment.due_date"
            [index]="i + 1"
            [isUpfrontAmount]="installment.upfront_payment"
            [dueInFull]="dueInFull"
            [itemized]="itemized">
          </app-payment-plan-installment>
        </se-fe-grid-cell>
      </se-fe-grid>
}
    </se-fe-block>
}
  </se-fe-grid-cell>
}

  <se-fe-grid-cell seFeGridOpts="1/1@mobile">
    <se-fe-block seFeDataType="outline"  class="se-block--condensed se-block--no-margin">
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell seFeGridOpts="1/2@mobile">
          <strong
          [translate]="'PAYMENT_TERMS_SELECTOR.TITLES.total'"></strong>
        </se-fe-grid-cell>
        <se-fe-grid-cell seFeGridOpts="1/2@mobile">
          <se-fe-grid seFeGridOpts="right">
            <se-fe-grid-cell seFeGridOpts="shrink@mobile">
              <strong>{{ totalAmount | currency }}</strong>
            </se-fe-grid-cell>
          </se-fe-grid>
        </se-fe-grid-cell>
      </se-fe-grid>
    </se-fe-block>
  </se-fe-grid-cell>
</se-fe-grid>
